const POSTHOG_TOKEN = 'phc_xSLwLqTMjRTZYfnbMxoWE5v4naSMBVdFekE2bK7TXt3K'

let posthogPromise

/**
 * Loads and initialises PostHog once per session
 * @returns {Promise<import('posthog-js').PostHog>}
 */
export const loadPosthog = () => {
  if (posthogPromise === undefined) {
    posthogPromise = import('posthog-js').then(({ default: posthog }) => {
      posthog.init(POSTHOG_TOKEN, { api_host: 'https://eu.i.posthog.com', defaults: '2026-01-30' })

      return posthog
    })
  }

  return posthogPromise
}
